import { produce } from 'immer'
import {
  GET_ORGANIZATION_MEMBERS_FAILURE,
  GET_ORGANIZATION_MEMBERS_INIT,
  GET_ORGANIZATION_MEMBERS_SUCCESS,
  GetPeopleMembersActions,
} from 'src/app/PeopleMembers/redux/peopleMembers.actions'
import {
  initialState as initialPeopleMembersState,
  PeopleMembersState,
} from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import { organizationInfoRouteProps } from 'src/navigation/routeProps'
import {
  GET_ORGANIZATIONS_FAILURE,
  GET_ORGANIZATIONS_INIT,
  GET_ORGANIZATIONS_SUCCESS,
  GetOrganizationsActions,
} from 'src/redux/actions/data/organizations.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface OrganizationInfoState {
  isOrganizationsBeingEdited: boolean
  fetchSuccess: boolean
  fetchFailure: boolean
  puttingOrganizations: boolean
  orgMembers: PeopleMembersState
  patchingOrganizationApprover: boolean
}

export const initialState: OrganizationInfoState = {
  isOrganizationsBeingEdited: false,
  fetchSuccess: false,
  fetchFailure: false,
  puttingOrganizations: false,
  orgMembers: initialPeopleMembersState,
  patchingOrganizationApprover: false,
}

export type Actions = GetOrganizationsActions | GetPeopleMembersActions

const CoreOrganizationInfoReducer = (
  state = initialState,
  action: Actions,
): OrganizationInfoState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ORGANIZATIONS_INIT: {
        return draft
      }

      case GET_ORGANIZATIONS_FAILURE: {
        draft.fetchFailure = true
        return draft
      }

      case GET_ORGANIZATIONS_SUCCESS: {
        draft.fetchSuccess = true
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_INIT: {
        draft.orgMembers.loading = true
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_SUCCESS: {
        draft.orgMembers.loading = false
        draft.orgMembers.totalItems = action.payload.pagination.totalItems
        draft.orgMembers.ids =
          action.payload.pagination.page === 0
            ? action.payload.users.map((user) => user.id)
            : [
                ...draft.orgMembers.ids,
                ...action.payload.users.map((user) => user.id),
              ]
        draft.orgMembers.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.orgMembers.page = action.payload.pagination.page
        draft.orgMembers.numberOfPages = action.payload.pagination.numberOfPages
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_FAILURE: {
        const errors = parseBackendErrors(action.payload)

        draft.orgMembers.loading = false
        draft.orgMembers.complete = true
        draft.orgMembers.getOrgMembersTopLevelError = errors.topLevelError
        draft.orgMembers.getOrgMembersErrorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const OrganizationInfoReducer = createBackgroundReducer(
  organizationInfoRouteProps,
  initialState,
  CoreOrganizationInfoReducer,
)

export default OrganizationInfoReducer
